// JOH World — de JOH Gym: warme old-school boksschool (gedeeld door Level 2 & 3).
import { PAL, VW, pixelText } from "./engine";

// variant: "floor" (push-up ruimte, breed) | "bag" (heavy-bag hoek, donkerder)
export function drawGym(ctx, t, variant = "floor") {
  // muur: warme baksteen
  ctx.fillStyle = variant === "bag" ? "#2E1B12" : "#3A2318";
  ctx.fillRect(0, 0, VW, 216);
  ctx.fillStyle = variant === "bag" ? "#382216" : "#452A1C";
  for (let row = 0; row < 9; row++) {
    const off = row % 2 === 0 ? 0 : 24;
    for (let x = -24; x < VW + 24; x += 48) {
      ctx.fillRect(x + off, 12 + row * 16, 46, 14);
    }
  }

  // houten vloer
  ctx.fillStyle = PAL.wood;
  ctx.fillRect(0, 156, VW, 60);
  ctx.fillStyle = PAL.woodDark;
  for (let i = 0; i < 12; i++) ctx.fillRect(0, 160 + i * 5, VW, 1);
  ctx.fillStyle = "rgba(0,0,0,0.18)";
  ctx.fillRect(0, 156, VW, 4);

  // plafondbalken
  ctx.fillStyle = "#241610";
  ctx.fillRect(0, 0, VW, 12);
  for (let i = 0; i < 5; i++) ctx.fillRect(30 + i * 84, 0, 10, 20);

  // boksring op de achtergrond (links)
  if (variant === "floor") {
    ctx.fillStyle = "#1E1E24";
    ctx.fillRect(8, 108, 120, 48); // platform
    ctx.fillStyle = "#33333C";
    ctx.fillRect(8, 104, 120, 6);
    const posts = [10, 124];
    for (const px of posts) {
      ctx.fillStyle = PAL.metal;
      ctx.fillRect(px, 62, 5, 46);
      ctx.fillStyle = PAL.yellow;
      ctx.fillRect(px - 1, 58, 7, 7);
    }
    for (const [ry, rc] of [[70, PAL.red], [80, PAL.cream], [90, PAL.red]]) {
      ctx.fillStyle = rc;
      ctx.fillRect(12, ry, 114, 3);
    }
    // speed bag rechtsboven
    ctx.fillStyle = PAL.woodDark;
    ctx.fillRect(322, 30, 34, 4);
    ctx.fillStyle = PAL.brown;
    ctx.beginPath();
    ctx.ellipse(339, 44 + Math.sin(t * 3) * 1, 7, 10, 0, 0, Math.PI * 2);
    ctx.fill();
  }

  // posters + branding
  drawPoster(ctx, 150, 34, "JOH.", PAL.yellow);
  drawPoster(ctx, 210, 40, "R.D.U.", PAL.cream, 6);
  drawPoster(ctx, 262, 34, variant === "bag" ? "BAG\nWORK" : "NO\nEXCUSES", PAL.red, 6);

  // Congolese + Palestijnse vlag aan de gymwand (subtiel, alleen Level 2)
  if (variant === "floor") {
    ctx.globalAlpha = 0.62;
    drawFlagLine(ctx, 48, 18);
    drawFlagDRC(ctx, 34, 18);
    drawFlagLine(ctx, 96, 18);
    drawFlagPAL(ctx, 82, 18);
    ctx.globalAlpha = 1;
  }

  // lockers rechts (alleen floor-variant)
  if (variant === "floor") {
    ctx.fillStyle = "#3A3F4A";
    ctx.fillRect(330, 84, 46, 72);
    ctx.fillStyle = "#2C313A";
    for (let i = 0; i < 3; i++) ctx.fillRect(332 + i * 15, 86, 13, 68);
    ctx.fillStyle = PAL.metal;
    for (let i = 0; i < 3; i++) ctx.fillRect(341 + i * 15, 116, 3, 5);
    // bank + dumbbells
    ctx.fillStyle = PAL.woodDark;
    ctx.fillRect(140, 138, 52, 6);
    ctx.fillRect(146, 144, 5, 12);
    ctx.fillRect(180, 144, 5, 12);
    ctx.fillStyle = PAL.metal;
    ctx.fillRect(196, 146, 14, 4);
    ctx.fillRect(193, 144, 4, 8);
    ctx.fillRect(209, 144, 4, 8);
    // jump rope
    ctx.strokeStyle = PAL.cream;
    ctx.lineWidth = 1;
    ctx.beginPath();
    ctx.arc(240, 148, 8, 0, Math.PI, false);
    ctx.stroke();
  }

  // lichtbundels
  ctx.globalAlpha = 0.07;
  ctx.fillStyle = PAL.yellow;
  ctx.beginPath();
  ctx.moveTo(120, 12); ctx.lineTo(170, 12); ctx.lineTo(200, 156); ctx.lineTo(90, 156);
  ctx.closePath(); ctx.fill();
  ctx.globalAlpha = 1;
}

function drawPoster(ctx, x, y, text, color, size = 8) {
  ctx.fillStyle = PAL.beige;
  ctx.fillRect(x, y, 44, 40);
  ctx.fillStyle = "#C9B896";
  ctx.fillRect(x, y + 36, 44, 4);
  const lines = text.split("\n");
  lines.forEach((ln, i) => pixelText(ctx, ln, x + 22, y + 8 + i * 11, size, color, "center"));
}

// ophangkoordje vanaf het plafond
function drawFlagLine(ctx, cx, y) {
  ctx.fillStyle = "#1E130D";
  ctx.fillRect(cx, 12, 1, y - 12);
}

// Congolese vlag (pixel-versie): blauw veld, gele ster, rode diagonaal met gele rand
function drawFlagDRC(ctx, x, y, w = 34, h = 22) {
  ctx.fillStyle = "#3E7FC4";
  ctx.fillRect(x, y, w, h);
  // diagonale band (onder-links → boven-rechts): eerst gele rand, dan rood eroverheen
  ctx.save();
  ctx.beginPath();
  ctx.rect(x, y, w, h);
  ctx.clip();
  ctx.strokeStyle = "#F5D020";
  ctx.lineWidth = 8;
  ctx.beginPath();
  ctx.moveTo(x - 3, y + h + 3);
  ctx.lineTo(x + w + 3, y - 3);
  ctx.stroke();
  ctx.strokeStyle = "#CE3426";
  ctx.lineWidth = 4.5;
  ctx.beginPath();
  ctx.moveTo(x - 3, y + h + 3);
  ctx.lineTo(x + w + 3, y - 3);
  ctx.stroke();
  ctx.restore();
  // gele ster linksboven
  const sx = x + 6, sy = y + 6;
  ctx.fillStyle = "#F5D020";
  ctx.fillRect(sx - 1, sy - 4, 2, 8);
  ctx.fillRect(sx - 4, sy - 1, 8, 2);
  ctx.fillRect(sx - 3, sy - 3, 2, 2);
  ctx.fillRect(sx + 1, sy - 3, 2, 2);
  ctx.fillRect(sx - 3, sy + 1, 2, 2);
  ctx.fillRect(sx + 1, sy + 1, 2, 2);
}

// Palestijnse vlag (pixel-versie): zwart/wit/groen banen + rode driehoek
function drawFlagPAL(ctx, x, y, w = 34, h = 22) {
  const sh = Math.ceil(h / 3);
  ctx.fillStyle = "#151515";
  ctx.fillRect(x, y, w, sh);
  ctx.fillStyle = "#F0EDE6";
  ctx.fillRect(x, y + sh, w, sh);
  ctx.fillStyle = "#2E7A3E";
  ctx.fillRect(x, y + 2 * sh, w, h - 2 * sh);
  ctx.fillStyle = "#C22A2A";
  ctx.beginPath();
  ctx.moveTo(x, y);
  ctx.lineTo(x, y + h);
  ctx.lineTo(x + 13, y + h / 2);
  ctx.closePath();
  ctx.fill();
}
